import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { errorMessagesMap } from 'src/app/constants/error-messages';
import { MainCardTypes } from 'src/app/interfaces/firstPartyTiles';
import { ProductType, User } from 'src/app/interfaces/user';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { PaymentConfigService } from 'src/app/services/payment-config/payment-config.service';
import { environment } from 'src/environments/environment';
import { IdentialertSubSelectionModalComponent } from '../subscription-pages/identialert-sub-selection-modal/identialert-sub-selection-modal.component';

@Component({
  selector: 'app-product-plan-card',
  templateUrl: './product-plan-card.component.html',
  styleUrls: ['./product-plan-card.component.scss'],
})

export class ProductPlanCardComponent implements OnInit {

  @Input() public productPlanCard: MainCardTypes;
  @Input() public user: User;
  @Input() public imagePosition: string = 'center 20%';
  @Input() public disabled: boolean = false;
  
  public title: string;
  public subtitleText: string;
  public price: string;
  public features: string[];
  public backgroundImage: string;
  public buyButtonText: string;
  public MainCardTypes = MainCardTypes;
  public isUpgrade: boolean;
  private userCurrentProductType: number;
  
  public badge: string;
  public tag: string;
  public isPremiumProductType: boolean;

  public plan2Name: string;
  public plan2YearlyPrice: string;
  public plan2Benefits: string[];

  public plan3Name: string;
  public plan3YearlyPrice: string;
  public plan3Benefits: string[];

  @Output() onError = new EventEmitter<string>();


  constructor(
    private configService: ConfigService,
    private checkoutService: CheckoutService,
    private modalService: NgbModal,
    private paymentConfigService: PaymentConfigService,
  ) {
    this.plan2YearlyPrice = this.configService.getTextFromKey('2-plan-yearly-price');
    this.plan2Name = this.configService.getTextFromKey('2-plan-name');
    this.plan2Benefits = this.configService.getListContentFromKey('2-plan-benefits');

    this.plan3YearlyPrice = this.configService.getTextFromKey('3-plan-yearly-price');
    this.plan3Name = this.configService.getTextFromKey('3-plan-name');
    this.plan3Benefits = this.configService.getListContentFromKey('3-plan-benefits');

    this.plan2YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.Premium) ?? this.plan2YearlyPrice;
    this.plan3YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.Locator) ?? this.plan3YearlyPrice;
  }

  ngOnInit(): void {
    this.buildCardContent();
    this.isPremiumProductType = this.productPlanCard === MainCardTypes.PremiumSubscription;
    this.isUpgrade = this.userCurrentProductType === ProductType.Basic;
    if (this.user) {
      this.userCurrentProductType = this.user.productType;
    }
  }

  onBuyNow(isPremiumProductType: boolean) {
    if (isPremiumProductType) {
      this.buyIdentiAlertSubscription();
    } else {
      this.checkoutService.checkout([environment.stripePlans.smartTagSubscription]).subscribe({
        error: () => this.onError.emit(errorMessagesMap.generic_error_message),
      });
    }
  }

  public buyIdentiAlertSubscription() {
    const identialertSubSelectionModalRef = this.modalService.open(
      IdentialertSubSelectionModalComponent,
      {
        backdrop: 'static',
        centered: true,
        size: 'md',
      }
    );
    identialertSubSelectionModalRef.componentInstance.modalRef = identialertSubSelectionModalRef;
    identialertSubSelectionModalRef.componentInstance.isUpgrade = this.isUpgrade;
  }

  private buildCardContent() {
    switch (this.productPlanCard) {
      case MainCardTypes.SmartTag:
        this.title = this.plan3Name;
        this.price = this.plan3YearlyPrice;
        this.subtitleText = 'Faster reunification than with a microchip alone.';
        this.badge = 'New!';
        this.tag = '';
        this.backgroundImage = '/assets/images/product-plan-card/tag-card-top.webp';
        this.buyButtonText = 'Buy now';
        this.features = this.plan3Benefits;
      break;

      case MainCardTypes.PremiumSubscription:
        this.title = this.plan2Name;
        this.price = this.plan2YearlyPrice;
        this.subtitleText = 'Truffle\'s lifeline, anytime. Stay prepared and reunite with your pets faster';
        this.badge = '';
        this.tag = 'Lost & Found Protection';
        this.backgroundImage = '/assets/images/product-plan-card/alert-card-top.webp';
        this.buyButtonText = 'Buy now';
        this.features = this.plan2Benefits;
      break;
    }
  }
}
